module.exports = __webpack_public_path__ + "img/Recall_By_Category.87c812e5.png";